import { values } from 'lodash';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { EventRequestResponseSchema } from '../../generic/event-response/event-request-response-schema';

import { EventRequestTransactionResponseError } from './event-request-transaction-response-error';

export class EventRequestTransactionResponseSchema extends EventRequestResponseSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;

    public static readonly error = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[EventRequestTransactionResponseSchema.error] = SchemaField.string(
      EventRequestResponseSchema.Defaults.error,
    )
      .optional()
      .valid(...values(EventRequestTransactionResponseError));
    /* eslint-enable */

    return parameters;
  }
}
